const City = {

    // FIELDS
    "name": "Pangalan",
    "status": "Katayuan",
    "search": "Maghanap",
    "country": "Bansa",
    "state": "Estado",

    // PAGE HEADER
    "city": "Lungsod",

    // ERROR
    "error_name": "Ilagay ang Pangalan",
    "error_country": "Piliin ang Bansa",
    "error_state": "Piliin ang Estado",
    "error_status": "Piliin ang Katayuan",

    // TABLE HEADER
    "table_name": "PANGALAN",
    "table_state": "ESTADO",
    "table_country": "BANSA",
    "table_status": "KATAYUAN",

}

export default City;